(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-html'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-html'.");
    }
    globalThis['kotlinx-html'] = factory(typeof globalThis['kotlinx-html'] === 'undefined' ? {} : globalThis['kotlinx-html'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.ba;
  var initMetadataForInterface = kotlin_kotlin.$_$.h9;
  var getProgressionLastElement = kotlin_kotlin.$_$.p7;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.c3;
  var Unit_instance = kotlin_kotlin.$_$.p2;
  var setOf = kotlin_kotlin.$_$.f6;
  var listOf = kotlin_kotlin.$_$.u5;
  var THROW_CCE = kotlin_kotlin.$_$.tc;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var KtMap = kotlin_kotlin.$_$.j4;
  var Entry = kotlin_kotlin.$_$.i4;
  var initMetadataForClass = kotlin_kotlin.$_$.e9;
  var VOID = kotlin_kotlin.$_$.b;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.k3;
  var emptyMap = kotlin_kotlin.$_$.f5;
  var initMetadataForObject = kotlin_kotlin.$_$.j9;
  var joinToString = kotlin_kotlin.$_$.o5;
  var KtSet = kotlin_kotlin.$_$.n4;
  var isInterface = kotlin_kotlin.$_$.s9;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.d3;
  var KtMutableMap = kotlin_kotlin.$_$.l4;
  var Enum = kotlin_kotlin.$_$.lc;
  var mapCapacity = kotlin_kotlin.$_$.w5;
  var coerceAtLeast = kotlin_kotlin.$_$.ha;
  var LinkedHashMap_init_$Create$_1 = kotlin_kotlin.$_$.b3;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.t2;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t3;
  var ensureNotNull = kotlin_kotlin.$_$.kd;
  var last = kotlin_kotlin.$_$.s5;
  var get_lastIndex = kotlin_kotlin.$_$.q5;
  var toString = kotlin_kotlin.$_$.da;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(AttributeEnum, 'AttributeEnum');
  function unaryPlus(_this__u8e3s4) {
    this.o1f(_this__u8e3s4);
  }
  function text(s) {
    this.j1f().p1f(s);
  }
  initMetadataForInterface(Tag, 'Tag');
  function raw(s) {
    this.n1f(s);
  }
  initMetadataForInterface(Unsafe, 'Unsafe');
  initMetadataForClass(SingletonStringMap, 'SingletonStringMap', VOID, VOID, [KtMap, Entry]);
  initMetadataForClass(DefaultUnsafe, 'DefaultUnsafe', DefaultUnsafe, VOID, [Unsafe]);
  initMetadataForClass(Attribute, 'Attribute');
  initMetadataForClass(StringAttribute, 'StringAttribute', StringAttribute, Attribute);
  initMetadataForClass(StringSetAttribute, 'StringSetAttribute', StringSetAttribute, Attribute);
  initMetadataForClass(BooleanAttribute, 'BooleanAttribute', BooleanAttribute, Attribute);
  initMetadataForClass(TickerAttribute, 'TickerAttribute', TickerAttribute, Attribute);
  initMetadataForClass(EnumAttribute, 'EnumAttribute', VOID, Attribute);
  initMetadataForObject(StringEncoder, 'StringEncoder');
  initMetadataForObject(StringSetEncoder, 'StringSetEncoder');
  initMetadataForClass(BooleanEncoder, 'BooleanEncoder', BooleanEncoder);
  initMetadataForObject(TickerEncoder, 'TickerEncoder');
  initMetadataForClass(EnumEncoder, 'EnumEncoder');
  initMetadataForClass(DelegatingMap, 'DelegatingMap', VOID, VOID, [KtMutableMap]);
  initMetadataForClass(FinalizeConsumer, 'FinalizeConsumer');
  initMetadataForClass(ButtonFormEncType, 'ButtonFormEncType', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(ButtonFormMethod, 'ButtonFormMethod', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(ButtonType, 'ButtonType', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(CommandType, 'CommandType', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(Dir, 'Dir', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(Draggable, 'Draggable', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(FormEncType, 'FormEncType', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(FormMethod, 'FormMethod', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(IframeSandbox, 'IframeSandbox', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(ImgLoading, 'ImgLoading', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(InputFormEncType, 'InputFormEncType', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(InputFormMethod, 'InputFormMethod', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(InputType, 'InputType', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(KeyGenKeyType, 'KeyGenKeyType', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(RunAt, 'RunAt', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(ScriptCrossorigin, 'ScriptCrossorigin', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(TextAreaWrap, 'TextAreaWrap', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(ThScope, 'ThScope', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(AreaShape, 'AreaShape', VOID, Enum, [AttributeEnum]);
  initMetadataForClass(HTMLTag, 'HTMLTag', VOID, VOID, [Tag]);
  initMetadataForClass(A, 'A', VOID, HTMLTag, [Tag]);
  initMetadataForClass(BUTTON, 'BUTTON', VOID, HTMLTag, [Tag]);
  initMetadataForClass(DIV, 'DIV', VOID, HTMLTag, [Tag]);
  initMetadataForClass(FORM, 'FORM', VOID, HTMLTag, [Tag]);
  initMetadataForClass(H3, 'H3', VOID, HTMLTag, [Tag]);
  initMetadataForClass(H4, 'H4', VOID, HTMLTag, [Tag]);
  initMetadataForClass(H2, 'H2', VOID, HTMLTag, [Tag]);
  initMetadataForClass(H1, 'H1', VOID, HTMLTag, [Tag]);
  initMetadataForClass(INPUT, 'INPUT', VOID, HTMLTag, [Tag]);
  initMetadataForClass(IMG, 'IMG', VOID, HTMLTag, [Tag]);
  initMetadataForClass(LABEL, 'LABEL', VOID, HTMLTag, [Tag]);
  initMetadataForClass(LI, 'LI', VOID, HTMLTag, [Tag]);
  initMetadataForClass(OPTION, 'OPTION', VOID, HTMLTag, [Tag]);
  initMetadataForClass(OL, 'OL', VOID, HTMLTag, [Tag]);
  initMetadataForClass(P, 'P', VOID, HTMLTag, [Tag]);
  initMetadataForClass(SVG, 'SVG', VOID, HTMLTag, [Tag]);
  initMetadataForClass(SELECT, 'SELECT', VOID, HTMLTag, [Tag]);
  initMetadataForClass(SPAN, 'SPAN', VOID, HTMLTag, [Tag]);
  initMetadataForClass(TABLE, 'TABLE', VOID, HTMLTag, [Tag]);
  initMetadataForClass(TR, 'TR', VOID, HTMLTag, [Tag]);
  initMetadataForClass(TH, 'TH', VOID, HTMLTag, [Tag]);
  initMetadataForClass(TD, 'TD', VOID, HTMLTag, [Tag]);
  initMetadataForClass(TEXTAREA, 'TEXTAREA', VOID, HTMLTag, [Tag]);
  initMetadataForClass(UL, 'UL', VOID, HTMLTag, [Tag]);
  initMetadataForClass(JSDOMBuilder, 'JSDOMBuilder');
  //endregion
  function get_emptyMap() {
    _init_properties_api_kt__c2p01k();
    return emptyMap_0;
  }
  var emptyMap_0;
  function AttributeEnum() {
  }
  function Tag() {
  }
  function Unsafe() {
  }
  function unsafe(_this__u8e3s4, block) {
    _init_properties_api_kt__c2p01k();
    return _this__u8e3s4.j1f().x1f(block);
  }
  function attributesMapOf(key, value) {
    _init_properties_api_kt__c2p01k();
    return value == null ? get_emptyMap() : singletonMapOf(key, value);
  }
  function attributesMapOf_0(pairs) {
    _init_properties_api_kt__c2p01k();
    var result = null;
    var nestedLast = pairs.length - 1 | 0;
    var inductionVariable = 0;
    var last = getProgressionLastElement(0, nestedLast, 2);
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 2 | 0;
        var k = pairs[i];
        var v = pairs[i + 1 | 0];
        if (!(k == null) && !(v == null)) {
          if (result == null) {
            // Inline function 'kotlin.collections.linkedMapOf' call
            result = LinkedHashMap_init_$Create$();
          }
          result.m2(k, v);
        }
      }
       while (!(i === last));
    var tmp1_elvis_lhs = result;
    return tmp1_elvis_lhs == null ? get_emptyMap() : tmp1_elvis_lhs;
  }
  function singletonMapOf(key, value) {
    _init_properties_api_kt__c2p01k();
    return new SingletonStringMap(key, value);
  }
  function SingletonStringMap(key, value) {
    this.y1f_1 = key;
    this.z1f_1 = value;
  }
  protoOf(SingletonStringMap).e2 = function () {
    return this.y1f_1;
  };
  protoOf(SingletonStringMap).f2 = function () {
    return this.z1f_1;
  };
  protoOf(SingletonStringMap).l2 = function () {
    return setOf(this);
  };
  protoOf(SingletonStringMap).j2 = function () {
    return setOf(this.y1f_1);
  };
  protoOf(SingletonStringMap).z = function () {
    return 1;
  };
  protoOf(SingletonStringMap).k2 = function () {
    return listOf(this.z1f_1);
  };
  protoOf(SingletonStringMap).m15 = function (key) {
    return key === this.y1f_1;
  };
  protoOf(SingletonStringMap).g2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.m15((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(SingletonStringMap).n15 = function (key) {
    return key === this.y1f_1 ? this.z1f_1 : null;
  };
  protoOf(SingletonStringMap).i2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.n15((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(SingletonStringMap).r = function () {
    return false;
  };
  protoOf(SingletonStringMap).toString = function () {
    return 'SingletonStringMap(key=' + this.y1f_1 + ', value=' + this.z1f_1 + ')';
  };
  protoOf(SingletonStringMap).hashCode = function () {
    var result = getStringHashCode(this.y1f_1);
    result = imul(result, 31) + getStringHashCode(this.z1f_1) | 0;
    return result;
  };
  protoOf(SingletonStringMap).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SingletonStringMap))
      return false;
    var tmp0_other_with_cast = other instanceof SingletonStringMap ? other : THROW_CCE();
    if (!(this.y1f_1 === tmp0_other_with_cast.y1f_1))
      return false;
    if (!(this.z1f_1 === tmp0_other_with_cast.z1f_1))
      return false;
    return true;
  };
  function DefaultUnsafe() {
    this.a1g_1 = StringBuilder_init_$Create$();
  }
  protoOf(DefaultUnsafe).n1f = function (_this__u8e3s4) {
    this.a1g_1.q(_this__u8e3s4);
  };
  protoOf(DefaultUnsafe).toString = function () {
    return this.a1g_1.toString();
  };
  var properties_initialized_api_kt_zfwuc6;
  function _init_properties_api_kt__c2p01k() {
    if (!properties_initialized_api_kt_zfwuc6) {
      properties_initialized_api_kt_zfwuc6 = true;
      emptyMap_0 = emptyMap();
    }
  }
  function Attribute(encoder) {
    this.b1g_1 = encoder;
  }
  protoOf(Attribute).c1g = function (thisRef, attributeName, value) {
    thisRef.l1f().m2(attributeName, this.b1g_1.d1g(attributeName, value));
  };
  function StringAttribute() {
    Attribute.call(this, StringEncoder_instance);
  }
  function StringSetAttribute() {
    Attribute.call(this, StringSetEncoder_instance);
  }
  function BooleanAttribute(trueValue, falseValue) {
    trueValue = trueValue === VOID ? 'true' : trueValue;
    falseValue = falseValue === VOID ? 'false' : falseValue;
    Attribute.call(this, new BooleanEncoder(trueValue, falseValue));
  }
  function TickerAttribute() {
    Attribute.call(this, TickerEncoder_instance);
  }
  protoOf(TickerAttribute).f1g = function (thisRef, attributeName, value) {
    if (value) {
      thisRef.l1f().m2(attributeName, attributeName);
    } else {
      thisRef.l1f().n2(attributeName);
    }
  };
  protoOf(TickerAttribute).c1g = function (thisRef, attributeName, value) {
    return this.f1g(thisRef, attributeName, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  function EnumAttribute(values) {
    Attribute.call(this, new EnumEncoder(values));
    this.h1g_1 = values;
  }
  function StringEncoder() {
  }
  protoOf(StringEncoder).i1g = function (attributeName, value) {
    return value;
  };
  protoOf(StringEncoder).d1g = function (attributeName, value) {
    return this.i1g(attributeName, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  var StringEncoder_instance;
  function StringEncoder_getInstance() {
    return StringEncoder_instance;
  }
  function StringSetEncoder() {
  }
  protoOf(StringSetEncoder).j1g = function (attributeName, value) {
    return joinToString(value, ' ');
  };
  protoOf(StringSetEncoder).d1g = function (attributeName, value) {
    return this.j1g(attributeName, (!(value == null) ? isInterface(value, KtSet) : false) ? value : THROW_CCE());
  };
  var StringSetEncoder_instance;
  function StringSetEncoder_getInstance() {
    return StringSetEncoder_instance;
  }
  function BooleanEncoder(trueValue, falseValue) {
    trueValue = trueValue === VOID ? 'true' : trueValue;
    falseValue = falseValue === VOID ? 'false' : falseValue;
    this.k1g_1 = trueValue;
    this.l1g_1 = falseValue;
  }
  protoOf(BooleanEncoder).m1g = function (attributeName, value) {
    return value ? this.k1g_1 : this.l1g_1;
  };
  protoOf(BooleanEncoder).d1g = function (attributeName, value) {
    return this.m1g(attributeName, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  function TickerEncoder() {
  }
  protoOf(TickerEncoder).m1g = function (attributeName, value) {
    return tickerEncode(value, attributeName);
  };
  protoOf(TickerEncoder).d1g = function (attributeName, value) {
    return this.m1g(attributeName, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  var TickerEncoder_instance;
  function TickerEncoder_getInstance() {
    return TickerEncoder_instance;
  }
  function EnumEncoder(valuesMap) {
    this.n1g_1 = valuesMap;
  }
  protoOf(EnumEncoder).o1g = function (attributeName, value) {
    return value.h1f();
  };
  protoOf(EnumEncoder).d1g = function (attributeName, value) {
    return this.o1g(attributeName, (!(value == null) ? isInterface(value, AttributeEnum) : false) ? value : THROW_CCE());
  };
  function tickerEncode(_this__u8e3s4, attributeName) {
    return _this__u8e3s4 ? attributeName : '';
  }
  function enumEncode(_this__u8e3s4) {
    return _this__u8e3s4.h1f();
  }
  function switchToMutable($this) {
    var tmp;
    if ($this.s1g_1) {
      tmp = $this.r1g_1;
    } else {
      $this.s1g_1 = true;
      $this.r1g_1 = LinkedHashMap_init_$Create$_0($this.r1g_1);
      tmp = $this.r1g_1;
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KtMutableMap) ? tmp_0 : THROW_CCE();
  }
  function DelegatingMap(initialValues, tag, consumer) {
    this.p1g_1 = tag;
    this.q1g_1 = consumer;
    this.r1g_1 = initialValues;
    this.s1g_1 = false;
  }
  protoOf(DelegatingMap).z = function () {
    return this.r1g_1.z();
  };
  protoOf(DelegatingMap).r = function () {
    return this.r1g_1.r();
  };
  protoOf(DelegatingMap).m15 = function (key) {
    return this.r1g_1.g2(key);
  };
  protoOf(DelegatingMap).g2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.m15((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(DelegatingMap).n15 = function (key) {
    return this.r1g_1.i2(key);
  };
  protoOf(DelegatingMap).i2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.n15((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(DelegatingMap).t1g = function (key, value) {
    var mutable = switchToMutable(this);
    var old = mutable.m2(key, value);
    if (!(old === value)) {
      this.q1g_1().u1g(this.p1g_1, key, value);
    }
    return old;
  };
  protoOf(DelegatingMap).m2 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.t1g(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(DelegatingMap).v1g = function (key) {
    var mutable = switchToMutable(this);
    var tmp0_safe_receiver = mutable.n2(key);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      this.q1g_1().u1g(this.p1g_1, key, null);
      tmp = tmp0_safe_receiver;
    }
    return tmp;
  };
  protoOf(DelegatingMap).n2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.v1g((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(DelegatingMap).p2 = function () {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.r1g_1.l2().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      this.q1g_1().u1g(this.p1g_1, element.e2(), null);
    }
    this.r1g_1 = emptyMap();
    this.s1g_1 = false;
  };
  protoOf(DelegatingMap).w1g = function () {
    return this.r1g_1.l2();
  };
  protoOf(DelegatingMap).j2 = function () {
    return switchToMutable(this).j2();
  };
  protoOf(DelegatingMap).k2 = function () {
    return switchToMutable(this).k2();
  };
  protoOf(DelegatingMap).l2 = function () {
    return switchToMutable(this).l2();
  };
  function onFinalize(_this__u8e3s4, block) {
    return new FinalizeConsumer(_this__u8e3s4, onFinalize$lambda(block));
  }
  function FinalizeConsumer(downstream, block) {
    this.x1g_1 = downstream;
    this.y1g_1 = block;
    this.z1g_1 = 0;
  }
  protoOf(FinalizeConsumer).a1h = function (tag) {
    this.x1g_1.a1h(tag);
    this.z1g_1 = this.z1g_1 + 1 | 0;
  };
  protoOf(FinalizeConsumer).b1h = function (tag) {
    this.x1g_1.b1h(tag);
    this.z1g_1 = this.z1g_1 - 1 | 0;
  };
  protoOf(FinalizeConsumer).u1g = function (tag, attribute, value) {
    return this.x1g_1.u1g(tag, attribute, value);
  };
  protoOf(FinalizeConsumer).c1h = function (tag, event, value) {
    return this.x1g_1.c1h(tag, event, value);
  };
  protoOf(FinalizeConsumer).p1f = function (content) {
    return this.x1g_1.p1f(content);
  };
  protoOf(FinalizeConsumer).x1f = function (block) {
    return this.x1g_1.x1f(block);
  };
  protoOf(FinalizeConsumer).d1h = function () {
    return this.y1g_1(this.x1g_1.d1h(), this.z1g_1 > 0);
  };
  function onFinalize$lambda($block) {
    return function (to, partial) {
      $block(to, partial);
      return to;
    };
  }
  function set_id(_this__u8e3s4, newValue) {
    get_attributeStringString().c1g(_this__u8e3s4, 'id', newValue);
  }
  function set_classes(_this__u8e3s4, newValue) {
    get_attributeSetStringStringSet().c1g(_this__u8e3s4, 'class', newValue);
  }
  function get_attributeStringString() {
    _init_properties_gen_attributes_kt__jy8yj0();
    return attributeStringString;
  }
  var attributeStringString;
  function get_attributeSetStringStringSet() {
    _init_properties_gen_attributes_kt__jy8yj0();
    return attributeSetStringStringSet;
  }
  var attributeSetStringStringSet;
  var attributeBooleanBoolean;
  var attributeBooleanBooleanOnOff;
  function get_attributeBooleanTicker() {
    _init_properties_gen_attributes_kt__jy8yj0();
    return attributeBooleanTicker;
  }
  var attributeBooleanTicker;
  var attributeButtonFormEncTypeEnumButtonFormEncTypeValues;
  var attributeButtonFormMethodEnumButtonFormMethodValues;
  function get_attributeButtonTypeEnumButtonTypeValues() {
    _init_properties_gen_attributes_kt__jy8yj0();
    return attributeButtonTypeEnumButtonTypeValues;
  }
  var attributeButtonTypeEnumButtonTypeValues;
  var attributeCommandTypeEnumCommandTypeValues;
  var attributeDirEnumDirValues;
  var attributeDraggableEnumDraggableValues;
  var attributeFormEncTypeEnumFormEncTypeValues;
  var attributeFormMethodEnumFormMethodValues;
  var attributeIframeSandboxEnumIframeSandboxValues;
  var attributeImgLoadingEnumImgLoadingValues;
  var attributeInputFormEncTypeEnumInputFormEncTypeValues;
  var attributeInputFormMethodEnumInputFormMethodValues;
  var attributeInputTypeEnumInputTypeValues;
  var attributeKeyGenKeyTypeEnumKeyGenKeyTypeValues;
  var attributeRunAtEnumRunAtValues;
  var attributeScriptCrossoriginEnumScriptCrossoriginValues;
  var attributeTextAreaWrapEnumTextAreaWrapValues;
  var attributeThScopeEnumThScopeValues;
  var properties_initialized_gen_attributes_kt_jgv7sa;
  function _init_properties_gen_attributes_kt__jy8yj0() {
    if (!properties_initialized_gen_attributes_kt_jgv7sa) {
      properties_initialized_gen_attributes_kt_jgv7sa = true;
      attributeStringString = new StringAttribute();
      attributeSetStringStringSet = new StringSetAttribute();
      attributeBooleanBoolean = new BooleanAttribute();
      attributeBooleanBooleanOnOff = new BooleanAttribute('on', 'off');
      attributeBooleanTicker = new TickerAttribute();
      attributeButtonFormEncTypeEnumButtonFormEncTypeValues = new EnumAttribute(get_buttonFormEncTypeValues());
      attributeButtonFormMethodEnumButtonFormMethodValues = new EnumAttribute(get_buttonFormMethodValues());
      attributeButtonTypeEnumButtonTypeValues = new EnumAttribute(get_buttonTypeValues());
      attributeCommandTypeEnumCommandTypeValues = new EnumAttribute(get_commandTypeValues());
      attributeDirEnumDirValues = new EnumAttribute(get_dirValues());
      attributeDraggableEnumDraggableValues = new EnumAttribute(get_draggableValues());
      attributeFormEncTypeEnumFormEncTypeValues = new EnumAttribute(get_formEncTypeValues());
      attributeFormMethodEnumFormMethodValues = new EnumAttribute(get_formMethodValues());
      attributeIframeSandboxEnumIframeSandboxValues = new EnumAttribute(get_iframeSandboxValues());
      attributeImgLoadingEnumImgLoadingValues = new EnumAttribute(get_imgLoadingValues());
      attributeInputFormEncTypeEnumInputFormEncTypeValues = new EnumAttribute(get_inputFormEncTypeValues());
      attributeInputFormMethodEnumInputFormMethodValues = new EnumAttribute(get_inputFormMethodValues());
      attributeInputTypeEnumInputTypeValues = new EnumAttribute(get_inputTypeValues());
      attributeKeyGenKeyTypeEnumKeyGenKeyTypeValues = new EnumAttribute(get_keyGenKeyTypeValues());
      attributeRunAtEnumRunAtValues = new EnumAttribute(get_runAtValues());
      attributeScriptCrossoriginEnumScriptCrossoriginValues = new EnumAttribute(get_scriptCrossoriginValues());
      attributeTextAreaWrapEnumTextAreaWrapValues = new EnumAttribute(get_textAreaWrapValues());
      attributeThScopeEnumThScopeValues = new EnumAttribute(get_thScopeValues());
    }
  }
  function get_dirValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return dirValues;
  }
  var dirValues;
  function get_draggableValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return draggableValues;
  }
  var draggableValues;
  function get_runAtValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return runAtValues;
  }
  var runAtValues;
  var areaShapeValues;
  function get_buttonFormEncTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return buttonFormEncTypeValues;
  }
  var buttonFormEncTypeValues;
  function get_buttonFormMethodValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return buttonFormMethodValues;
  }
  var buttonFormMethodValues;
  function get_buttonTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return buttonTypeValues;
  }
  var buttonTypeValues;
  function get_commandTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return commandTypeValues;
  }
  var commandTypeValues;
  function get_formEncTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return formEncTypeValues;
  }
  var formEncTypeValues;
  function get_formMethodValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return formMethodValues;
  }
  var formMethodValues;
  function get_iframeSandboxValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return iframeSandboxValues;
  }
  var iframeSandboxValues;
  function get_imgLoadingValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return imgLoadingValues;
  }
  var imgLoadingValues;
  function get_inputTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return inputTypeValues;
  }
  var inputTypeValues;
  function get_inputFormEncTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return inputFormEncTypeValues;
  }
  var inputFormEncTypeValues;
  function get_inputFormMethodValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return inputFormMethodValues;
  }
  var inputFormMethodValues;
  function get_keyGenKeyTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return keyGenKeyTypeValues;
  }
  var keyGenKeyTypeValues;
  function get_scriptCrossoriginValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return scriptCrossoriginValues;
  }
  var scriptCrossoriginValues;
  function get_textAreaWrapValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return textAreaWrapValues;
  }
  var textAreaWrapValues;
  function get_thScopeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return thScopeValues;
  }
  var thScopeValues;
  var ButtonFormEncType_multipartFormData_instance;
  var ButtonFormEncType_applicationXWwwFormUrlEncoded_instance;
  var ButtonFormEncType_textPlain_instance;
  function values() {
    return [ButtonFormEncType_multipartFormData_getInstance(), ButtonFormEncType_applicationXWwwFormUrlEncoded_getInstance(), ButtonFormEncType_textPlain_getInstance()];
  }
  var ButtonFormEncType_entriesInitialized;
  function ButtonFormEncType_initEntries() {
    if (ButtonFormEncType_entriesInitialized)
      return Unit_instance;
    ButtonFormEncType_entriesInitialized = true;
    ButtonFormEncType_multipartFormData_instance = new ButtonFormEncType('multipartFormData', 0, 'multipart/form-data');
    ButtonFormEncType_applicationXWwwFormUrlEncoded_instance = new ButtonFormEncType('applicationXWwwFormUrlEncoded', 1, 'application/x-www-form-urlencoded');
    ButtonFormEncType_textPlain_instance = new ButtonFormEncType('textPlain', 2, 'text/plain');
  }
  function ButtonFormEncType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.g1h_1 = realValue;
  }
  protoOf(ButtonFormEncType).h1f = function () {
    return this.g1h_1;
  };
  var ButtonFormMethod_get_instance;
  var ButtonFormMethod_post_instance;
  var ButtonFormMethod_put_instance;
  var ButtonFormMethod_delete_instance;
  var ButtonFormMethod_patch_instance;
  function values_0() {
    return [ButtonFormMethod_get_getInstance(), ButtonFormMethod_post_getInstance(), ButtonFormMethod_put_getInstance(), ButtonFormMethod_delete_getInstance(), ButtonFormMethod_patch_getInstance()];
  }
  var ButtonFormMethod_entriesInitialized;
  function ButtonFormMethod_initEntries() {
    if (ButtonFormMethod_entriesInitialized)
      return Unit_instance;
    ButtonFormMethod_entriesInitialized = true;
    ButtonFormMethod_get_instance = new ButtonFormMethod('get', 0, 'get');
    ButtonFormMethod_post_instance = new ButtonFormMethod('post', 1, 'post');
    ButtonFormMethod_put_instance = new ButtonFormMethod('put', 2, 'put');
    ButtonFormMethod_delete_instance = new ButtonFormMethod('delete', 3, 'delete');
    ButtonFormMethod_patch_instance = new ButtonFormMethod('patch', 4, 'patch');
  }
  function ButtonFormMethod(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.j1h_1 = realValue;
  }
  protoOf(ButtonFormMethod).h1f = function () {
    return this.j1h_1;
  };
  var ButtonType_button_instance;
  var ButtonType_reset_instance;
  var ButtonType_submit_instance;
  function values_1() {
    return [ButtonType_button_getInstance(), ButtonType_reset_getInstance(), ButtonType_submit_getInstance()];
  }
  var ButtonType_entriesInitialized;
  function ButtonType_initEntries() {
    if (ButtonType_entriesInitialized)
      return Unit_instance;
    ButtonType_entriesInitialized = true;
    ButtonType_button_instance = new ButtonType('button', 0, 'button');
    ButtonType_reset_instance = new ButtonType('reset', 1, 'reset');
    ButtonType_submit_instance = new ButtonType('submit', 2, 'submit');
  }
  function ButtonType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.m1h_1 = realValue;
  }
  protoOf(ButtonType).h1f = function () {
    return this.m1h_1;
  };
  var CommandType_command_instance;
  var CommandType_checkBox_instance;
  var CommandType_radio_instance;
  function values_2() {
    return [CommandType_command_getInstance(), CommandType_checkBox_getInstance(), CommandType_radio_getInstance()];
  }
  var CommandType_entriesInitialized;
  function CommandType_initEntries() {
    if (CommandType_entriesInitialized)
      return Unit_instance;
    CommandType_entriesInitialized = true;
    CommandType_command_instance = new CommandType('command', 0, 'command');
    CommandType_checkBox_instance = new CommandType('checkBox', 1, 'checkbox');
    CommandType_radio_instance = new CommandType('radio', 2, 'radio');
  }
  function CommandType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.p1h_1 = realValue;
  }
  protoOf(CommandType).h1f = function () {
    return this.p1h_1;
  };
  var Dir_ltr_instance;
  var Dir_rtl_instance;
  function values_3() {
    return [Dir_ltr_getInstance(), Dir_rtl_getInstance()];
  }
  var Dir_entriesInitialized;
  function Dir_initEntries() {
    if (Dir_entriesInitialized)
      return Unit_instance;
    Dir_entriesInitialized = true;
    Dir_ltr_instance = new Dir('ltr', 0, 'ltr');
    Dir_rtl_instance = new Dir('rtl', 1, 'rtl');
  }
  function Dir(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.s1h_1 = realValue;
  }
  protoOf(Dir).h1f = function () {
    return this.s1h_1;
  };
  var Draggable_htmlTrue_instance;
  var Draggable_htmlFalse_instance;
  var Draggable_auto_instance;
  function values_4() {
    return [Draggable_htmlTrue_getInstance(), Draggable_htmlFalse_getInstance(), Draggable_auto_getInstance()];
  }
  var Draggable_entriesInitialized;
  function Draggable_initEntries() {
    if (Draggable_entriesInitialized)
      return Unit_instance;
    Draggable_entriesInitialized = true;
    Draggable_htmlTrue_instance = new Draggable('htmlTrue', 0, 'true');
    Draggable_htmlFalse_instance = new Draggable('htmlFalse', 1, 'false');
    Draggable_auto_instance = new Draggable('auto', 2, 'auto');
  }
  function Draggable(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.v1h_1 = realValue;
  }
  protoOf(Draggable).h1f = function () {
    return this.v1h_1;
  };
  var FormEncType_multipartFormData_instance;
  var FormEncType_applicationXWwwFormUrlEncoded_instance;
  var FormEncType_textPlain_instance;
  function values_5() {
    return [FormEncType_multipartFormData_getInstance(), FormEncType_applicationXWwwFormUrlEncoded_getInstance(), FormEncType_textPlain_getInstance()];
  }
  var FormEncType_entriesInitialized;
  function FormEncType_initEntries() {
    if (FormEncType_entriesInitialized)
      return Unit_instance;
    FormEncType_entriesInitialized = true;
    FormEncType_multipartFormData_instance = new FormEncType('multipartFormData', 0, 'multipart/form-data');
    FormEncType_applicationXWwwFormUrlEncoded_instance = new FormEncType('applicationXWwwFormUrlEncoded', 1, 'application/x-www-form-urlencoded');
    FormEncType_textPlain_instance = new FormEncType('textPlain', 2, 'text/plain');
  }
  function FormEncType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.y1h_1 = realValue;
  }
  protoOf(FormEncType).h1f = function () {
    return this.y1h_1;
  };
  var FormMethod_get_instance;
  var FormMethod_post_instance;
  var FormMethod_put_instance;
  var FormMethod_delete_instance;
  var FormMethod_patch_instance;
  function values_6() {
    return [FormMethod_get_getInstance(), FormMethod_post_getInstance(), FormMethod_put_getInstance(), FormMethod_delete_getInstance(), FormMethod_patch_getInstance()];
  }
  var FormMethod_entriesInitialized;
  function FormMethod_initEntries() {
    if (FormMethod_entriesInitialized)
      return Unit_instance;
    FormMethod_entriesInitialized = true;
    FormMethod_get_instance = new FormMethod('get', 0, 'get');
    FormMethod_post_instance = new FormMethod('post', 1, 'post');
    FormMethod_put_instance = new FormMethod('put', 2, 'put');
    FormMethod_delete_instance = new FormMethod('delete', 3, 'delete');
    FormMethod_patch_instance = new FormMethod('patch', 4, 'patch');
  }
  function FormMethod(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.b1i_1 = realValue;
  }
  protoOf(FormMethod).h1f = function () {
    return this.b1i_1;
  };
  var IframeSandbox_allowSameOrigin_instance;
  var IframeSandbox_allowFormS_instance;
  var IframeSandbox_allowScripts_instance;
  function values_7() {
    return [IframeSandbox_allowSameOrigin_getInstance(), IframeSandbox_allowFormS_getInstance(), IframeSandbox_allowScripts_getInstance()];
  }
  var IframeSandbox_entriesInitialized;
  function IframeSandbox_initEntries() {
    if (IframeSandbox_entriesInitialized)
      return Unit_instance;
    IframeSandbox_entriesInitialized = true;
    IframeSandbox_allowSameOrigin_instance = new IframeSandbox('allowSameOrigin', 0, 'allow-same-origin');
    IframeSandbox_allowFormS_instance = new IframeSandbox('allowFormS', 1, 'allow-forms');
    IframeSandbox_allowScripts_instance = new IframeSandbox('allowScripts', 2, 'allow-scripts');
  }
  function IframeSandbox(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.e1i_1 = realValue;
  }
  protoOf(IframeSandbox).h1f = function () {
    return this.e1i_1;
  };
  var ImgLoading_eager_instance;
  var ImgLoading_lazy_instance;
  function values_8() {
    return [ImgLoading_eager_getInstance(), ImgLoading_lazy_getInstance()];
  }
  var ImgLoading_entriesInitialized;
  function ImgLoading_initEntries() {
    if (ImgLoading_entriesInitialized)
      return Unit_instance;
    ImgLoading_entriesInitialized = true;
    ImgLoading_eager_instance = new ImgLoading('eager', 0, 'eager');
    ImgLoading_lazy_instance = new ImgLoading('lazy', 1, 'lazy');
  }
  function ImgLoading(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.h1i_1 = realValue;
  }
  protoOf(ImgLoading).h1f = function () {
    return this.h1i_1;
  };
  var InputFormEncType_multipartFormData_instance;
  var InputFormEncType_applicationXWwwFormUrlEncoded_instance;
  var InputFormEncType_textPlain_instance;
  function values_9() {
    return [InputFormEncType_multipartFormData_getInstance(), InputFormEncType_applicationXWwwFormUrlEncoded_getInstance(), InputFormEncType_textPlain_getInstance()];
  }
  var InputFormEncType_entriesInitialized;
  function InputFormEncType_initEntries() {
    if (InputFormEncType_entriesInitialized)
      return Unit_instance;
    InputFormEncType_entriesInitialized = true;
    InputFormEncType_multipartFormData_instance = new InputFormEncType('multipartFormData', 0, 'multipart/form-data');
    InputFormEncType_applicationXWwwFormUrlEncoded_instance = new InputFormEncType('applicationXWwwFormUrlEncoded', 1, 'application/x-www-form-urlencoded');
    InputFormEncType_textPlain_instance = new InputFormEncType('textPlain', 2, 'text/plain');
  }
  function InputFormEncType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.k1i_1 = realValue;
  }
  protoOf(InputFormEncType).h1f = function () {
    return this.k1i_1;
  };
  var InputFormMethod_get_instance;
  var InputFormMethod_post_instance;
  var InputFormMethod_put_instance;
  var InputFormMethod_delete_instance;
  var InputFormMethod_patch_instance;
  function values_10() {
    return [InputFormMethod_get_getInstance(), InputFormMethod_post_getInstance(), InputFormMethod_put_getInstance(), InputFormMethod_delete_getInstance(), InputFormMethod_patch_getInstance()];
  }
  var InputFormMethod_entriesInitialized;
  function InputFormMethod_initEntries() {
    if (InputFormMethod_entriesInitialized)
      return Unit_instance;
    InputFormMethod_entriesInitialized = true;
    InputFormMethod_get_instance = new InputFormMethod('get', 0, 'get');
    InputFormMethod_post_instance = new InputFormMethod('post', 1, 'post');
    InputFormMethod_put_instance = new InputFormMethod('put', 2, 'put');
    InputFormMethod_delete_instance = new InputFormMethod('delete', 3, 'delete');
    InputFormMethod_patch_instance = new InputFormMethod('patch', 4, 'patch');
  }
  function InputFormMethod(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.n1i_1 = realValue;
  }
  protoOf(InputFormMethod).h1f = function () {
    return this.n1i_1;
  };
  var InputType_button_instance;
  var InputType_checkBox_instance;
  var InputType_color_instance;
  var InputType_date_instance;
  var InputType_dateTime_instance;
  var InputType_dateTimeLocal_instance;
  var InputType_email_instance;
  var InputType_file_instance;
  var InputType_hidden_instance;
  var InputType_image_instance;
  var InputType_month_instance;
  var InputType_number_instance;
  var InputType_password_instance;
  var InputType_radio_instance;
  var InputType_range_instance;
  var InputType_reset_instance;
  var InputType_search_instance;
  var InputType_submit_instance;
  var InputType_text_instance;
  var InputType_tel_instance;
  var InputType_time_instance;
  var InputType_url_instance;
  var InputType_week_instance;
  function values_11() {
    return [InputType_button_getInstance(), InputType_checkBox_getInstance(), InputType_color_getInstance(), InputType_date_getInstance(), InputType_dateTime_getInstance(), InputType_dateTimeLocal_getInstance(), InputType_email_getInstance(), InputType_file_getInstance(), InputType_hidden_getInstance(), InputType_image_getInstance(), InputType_month_getInstance(), InputType_number_getInstance(), InputType_password_getInstance(), InputType_radio_getInstance(), InputType_range_getInstance(), InputType_reset_getInstance(), InputType_search_getInstance(), InputType_submit_getInstance(), InputType_text_getInstance(), InputType_tel_getInstance(), InputType_time_getInstance(), InputType_url_getInstance(), InputType_week_getInstance()];
  }
  var InputType_entriesInitialized;
  function InputType_initEntries() {
    if (InputType_entriesInitialized)
      return Unit_instance;
    InputType_entriesInitialized = true;
    InputType_button_instance = new InputType('button', 0, 'button');
    InputType_checkBox_instance = new InputType('checkBox', 1, 'checkbox');
    InputType_color_instance = new InputType('color', 2, 'color');
    InputType_date_instance = new InputType('date', 3, 'date');
    InputType_dateTime_instance = new InputType('dateTime', 4, 'datetime');
    InputType_dateTimeLocal_instance = new InputType('dateTimeLocal', 5, 'datetime-local');
    InputType_email_instance = new InputType('email', 6, 'email');
    InputType_file_instance = new InputType('file', 7, 'file');
    InputType_hidden_instance = new InputType('hidden', 8, 'hidden');
    InputType_image_instance = new InputType('image', 9, 'image');
    InputType_month_instance = new InputType('month', 10, 'month');
    InputType_number_instance = new InputType('number', 11, 'number');
    InputType_password_instance = new InputType('password', 12, 'password');
    InputType_radio_instance = new InputType('radio', 13, 'radio');
    InputType_range_instance = new InputType('range', 14, 'range');
    InputType_reset_instance = new InputType('reset', 15, 'reset');
    InputType_search_instance = new InputType('search', 16, 'search');
    InputType_submit_instance = new InputType('submit', 17, 'submit');
    InputType_text_instance = new InputType('text', 18, 'text');
    InputType_tel_instance = new InputType('tel', 19, 'tel');
    InputType_time_instance = new InputType('time', 20, 'time');
    InputType_url_instance = new InputType('url', 21, 'url');
    InputType_week_instance = new InputType('week', 22, 'week');
  }
  function InputType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.q1i_1 = realValue;
  }
  protoOf(InputType).h1f = function () {
    return this.q1i_1;
  };
  var KeyGenKeyType_rsa_instance;
  function values_12() {
    return [KeyGenKeyType_rsa_getInstance()];
  }
  var KeyGenKeyType_entriesInitialized;
  function KeyGenKeyType_initEntries() {
    if (KeyGenKeyType_entriesInitialized)
      return Unit_instance;
    KeyGenKeyType_entriesInitialized = true;
    KeyGenKeyType_rsa_instance = new KeyGenKeyType('rsa', 0, 'rsa');
  }
  function KeyGenKeyType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.t1i_1 = realValue;
  }
  protoOf(KeyGenKeyType).h1f = function () {
    return this.t1i_1;
  };
  var RunAt_server_instance;
  function values_13() {
    return [RunAt_server_getInstance()];
  }
  var RunAt_entriesInitialized;
  function RunAt_initEntries() {
    if (RunAt_entriesInitialized)
      return Unit_instance;
    RunAt_entriesInitialized = true;
    RunAt_server_instance = new RunAt('server', 0, 'server');
  }
  function RunAt(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.w1i_1 = realValue;
  }
  protoOf(RunAt).h1f = function () {
    return this.w1i_1;
  };
  var ScriptCrossorigin_anonymous_instance;
  var ScriptCrossorigin_useCredentials_instance;
  function values_14() {
    return [ScriptCrossorigin_anonymous_getInstance(), ScriptCrossorigin_useCredentials_getInstance()];
  }
  var ScriptCrossorigin_entriesInitialized;
  function ScriptCrossorigin_initEntries() {
    if (ScriptCrossorigin_entriesInitialized)
      return Unit_instance;
    ScriptCrossorigin_entriesInitialized = true;
    ScriptCrossorigin_anonymous_instance = new ScriptCrossorigin('anonymous', 0, 'anonymous');
    ScriptCrossorigin_useCredentials_instance = new ScriptCrossorigin('useCredentials', 1, 'use-credentials');
  }
  function ScriptCrossorigin(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.z1i_1 = realValue;
  }
  protoOf(ScriptCrossorigin).h1f = function () {
    return this.z1i_1;
  };
  var TextAreaWrap_hard_instance;
  var TextAreaWrap_soft_instance;
  function values_15() {
    return [TextAreaWrap_hard_getInstance(), TextAreaWrap_soft_getInstance()];
  }
  var TextAreaWrap_entriesInitialized;
  function TextAreaWrap_initEntries() {
    if (TextAreaWrap_entriesInitialized)
      return Unit_instance;
    TextAreaWrap_entriesInitialized = true;
    TextAreaWrap_hard_instance = new TextAreaWrap('hard', 0, 'hard');
    TextAreaWrap_soft_instance = new TextAreaWrap('soft', 1, 'soft');
  }
  function TextAreaWrap(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.c1j_1 = realValue;
  }
  protoOf(TextAreaWrap).h1f = function () {
    return this.c1j_1;
  };
  var ThScope_col_instance;
  var ThScope_colGroup_instance;
  var ThScope_row_instance;
  var ThScope_rowGroup_instance;
  function values_16() {
    return [ThScope_col_getInstance(), ThScope_colGroup_getInstance(), ThScope_row_getInstance(), ThScope_rowGroup_getInstance()];
  }
  var ThScope_entriesInitialized;
  function ThScope_initEntries() {
    if (ThScope_entriesInitialized)
      return Unit_instance;
    ThScope_entriesInitialized = true;
    ThScope_col_instance = new ThScope('col', 0, 'col');
    ThScope_colGroup_instance = new ThScope('colGroup', 1, 'colgroup');
    ThScope_row_instance = new ThScope('row', 2, 'row');
    ThScope_rowGroup_instance = new ThScope('rowGroup', 3, 'rowgroup');
  }
  function ThScope(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.f1j_1 = realValue;
  }
  protoOf(ThScope).h1f = function () {
    return this.f1j_1;
  };
  var AreaShape_rect_instance;
  var AreaShape_circle_instance;
  var AreaShape_poly_instance;
  var AreaShape_default_instance;
  function values_17() {
    return [AreaShape_rect_getInstance(), AreaShape_circle_getInstance(), AreaShape_poly_getInstance(), AreaShape_default_getInstance()];
  }
  var AreaShape_entriesInitialized;
  function AreaShape_initEntries() {
    if (AreaShape_entriesInitialized)
      return Unit_instance;
    AreaShape_entriesInitialized = true;
    AreaShape_rect_instance = new AreaShape('rect', 0, 'rect');
    AreaShape_circle_instance = new AreaShape('circle', 1, 'circle');
    AreaShape_poly_instance = new AreaShape('poly', 2, 'poly');
    AreaShape_default_instance = new AreaShape('default', 3, 'default');
  }
  function AreaShape(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.i1j_1 = realValue;
  }
  protoOf(AreaShape).h1f = function () {
    return this.i1j_1;
  };
  function ButtonFormEncType_multipartFormData_getInstance() {
    ButtonFormEncType_initEntries();
    return ButtonFormEncType_multipartFormData_instance;
  }
  function ButtonFormEncType_applicationXWwwFormUrlEncoded_getInstance() {
    ButtonFormEncType_initEntries();
    return ButtonFormEncType_applicationXWwwFormUrlEncoded_instance;
  }
  function ButtonFormEncType_textPlain_getInstance() {
    ButtonFormEncType_initEntries();
    return ButtonFormEncType_textPlain_instance;
  }
  function ButtonFormMethod_get_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_get_instance;
  }
  function ButtonFormMethod_post_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_post_instance;
  }
  function ButtonFormMethod_put_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_put_instance;
  }
  function ButtonFormMethod_delete_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_delete_instance;
  }
  function ButtonFormMethod_patch_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_patch_instance;
  }
  function ButtonType_button_getInstance() {
    ButtonType_initEntries();
    return ButtonType_button_instance;
  }
  function ButtonType_reset_getInstance() {
    ButtonType_initEntries();
    return ButtonType_reset_instance;
  }
  function ButtonType_submit_getInstance() {
    ButtonType_initEntries();
    return ButtonType_submit_instance;
  }
  function CommandType_command_getInstance() {
    CommandType_initEntries();
    return CommandType_command_instance;
  }
  function CommandType_checkBox_getInstance() {
    CommandType_initEntries();
    return CommandType_checkBox_instance;
  }
  function CommandType_radio_getInstance() {
    CommandType_initEntries();
    return CommandType_radio_instance;
  }
  function Dir_ltr_getInstance() {
    Dir_initEntries();
    return Dir_ltr_instance;
  }
  function Dir_rtl_getInstance() {
    Dir_initEntries();
    return Dir_rtl_instance;
  }
  function Draggable_htmlTrue_getInstance() {
    Draggable_initEntries();
    return Draggable_htmlTrue_instance;
  }
  function Draggable_htmlFalse_getInstance() {
    Draggable_initEntries();
    return Draggable_htmlFalse_instance;
  }
  function Draggable_auto_getInstance() {
    Draggable_initEntries();
    return Draggable_auto_instance;
  }
  function FormEncType_multipartFormData_getInstance() {
    FormEncType_initEntries();
    return FormEncType_multipartFormData_instance;
  }
  function FormEncType_applicationXWwwFormUrlEncoded_getInstance() {
    FormEncType_initEntries();
    return FormEncType_applicationXWwwFormUrlEncoded_instance;
  }
  function FormEncType_textPlain_getInstance() {
    FormEncType_initEntries();
    return FormEncType_textPlain_instance;
  }
  function FormMethod_get_getInstance() {
    FormMethod_initEntries();
    return FormMethod_get_instance;
  }
  function FormMethod_post_getInstance() {
    FormMethod_initEntries();
    return FormMethod_post_instance;
  }
  function FormMethod_put_getInstance() {
    FormMethod_initEntries();
    return FormMethod_put_instance;
  }
  function FormMethod_delete_getInstance() {
    FormMethod_initEntries();
    return FormMethod_delete_instance;
  }
  function FormMethod_patch_getInstance() {
    FormMethod_initEntries();
    return FormMethod_patch_instance;
  }
  function IframeSandbox_allowSameOrigin_getInstance() {
    IframeSandbox_initEntries();
    return IframeSandbox_allowSameOrigin_instance;
  }
  function IframeSandbox_allowFormS_getInstance() {
    IframeSandbox_initEntries();
    return IframeSandbox_allowFormS_instance;
  }
  function IframeSandbox_allowScripts_getInstance() {
    IframeSandbox_initEntries();
    return IframeSandbox_allowScripts_instance;
  }
  function ImgLoading_eager_getInstance() {
    ImgLoading_initEntries();
    return ImgLoading_eager_instance;
  }
  function ImgLoading_lazy_getInstance() {
    ImgLoading_initEntries();
    return ImgLoading_lazy_instance;
  }
  function InputFormEncType_multipartFormData_getInstance() {
    InputFormEncType_initEntries();
    return InputFormEncType_multipartFormData_instance;
  }
  function InputFormEncType_applicationXWwwFormUrlEncoded_getInstance() {
    InputFormEncType_initEntries();
    return InputFormEncType_applicationXWwwFormUrlEncoded_instance;
  }
  function InputFormEncType_textPlain_getInstance() {
    InputFormEncType_initEntries();
    return InputFormEncType_textPlain_instance;
  }
  function InputFormMethod_get_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_get_instance;
  }
  function InputFormMethod_post_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_post_instance;
  }
  function InputFormMethod_put_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_put_instance;
  }
  function InputFormMethod_delete_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_delete_instance;
  }
  function InputFormMethod_patch_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_patch_instance;
  }
  function InputType_button_getInstance() {
    InputType_initEntries();
    return InputType_button_instance;
  }
  function InputType_checkBox_getInstance() {
    InputType_initEntries();
    return InputType_checkBox_instance;
  }
  function InputType_color_getInstance() {
    InputType_initEntries();
    return InputType_color_instance;
  }
  function InputType_date_getInstance() {
    InputType_initEntries();
    return InputType_date_instance;
  }
  function InputType_dateTime_getInstance() {
    InputType_initEntries();
    return InputType_dateTime_instance;
  }
  function InputType_dateTimeLocal_getInstance() {
    InputType_initEntries();
    return InputType_dateTimeLocal_instance;
  }
  function InputType_email_getInstance() {
    InputType_initEntries();
    return InputType_email_instance;
  }
  function InputType_file_getInstance() {
    InputType_initEntries();
    return InputType_file_instance;
  }
  function InputType_hidden_getInstance() {
    InputType_initEntries();
    return InputType_hidden_instance;
  }
  function InputType_image_getInstance() {
    InputType_initEntries();
    return InputType_image_instance;
  }
  function InputType_month_getInstance() {
    InputType_initEntries();
    return InputType_month_instance;
  }
  function InputType_number_getInstance() {
    InputType_initEntries();
    return InputType_number_instance;
  }
  function InputType_password_getInstance() {
    InputType_initEntries();
    return InputType_password_instance;
  }
  function InputType_radio_getInstance() {
    InputType_initEntries();
    return InputType_radio_instance;
  }
  function InputType_range_getInstance() {
    InputType_initEntries();
    return InputType_range_instance;
  }
  function InputType_reset_getInstance() {
    InputType_initEntries();
    return InputType_reset_instance;
  }
  function InputType_search_getInstance() {
    InputType_initEntries();
    return InputType_search_instance;
  }
  function InputType_submit_getInstance() {
    InputType_initEntries();
    return InputType_submit_instance;
  }
  function InputType_text_getInstance() {
    InputType_initEntries();
    return InputType_text_instance;
  }
  function InputType_tel_getInstance() {
    InputType_initEntries();
    return InputType_tel_instance;
  }
  function InputType_time_getInstance() {
    InputType_initEntries();
    return InputType_time_instance;
  }
  function InputType_url_getInstance() {
    InputType_initEntries();
    return InputType_url_instance;
  }
  function InputType_week_getInstance() {
    InputType_initEntries();
    return InputType_week_instance;
  }
  function KeyGenKeyType_rsa_getInstance() {
    KeyGenKeyType_initEntries();
    return KeyGenKeyType_rsa_instance;
  }
  function RunAt_server_getInstance() {
    RunAt_initEntries();
    return RunAt_server_instance;
  }
  function ScriptCrossorigin_anonymous_getInstance() {
    ScriptCrossorigin_initEntries();
    return ScriptCrossorigin_anonymous_instance;
  }
  function ScriptCrossorigin_useCredentials_getInstance() {
    ScriptCrossorigin_initEntries();
    return ScriptCrossorigin_useCredentials_instance;
  }
  function TextAreaWrap_hard_getInstance() {
    TextAreaWrap_initEntries();
    return TextAreaWrap_hard_instance;
  }
  function TextAreaWrap_soft_getInstance() {
    TextAreaWrap_initEntries();
    return TextAreaWrap_soft_instance;
  }
  function ThScope_col_getInstance() {
    ThScope_initEntries();
    return ThScope_col_instance;
  }
  function ThScope_colGroup_getInstance() {
    ThScope_initEntries();
    return ThScope_colGroup_instance;
  }
  function ThScope_row_getInstance() {
    ThScope_initEntries();
    return ThScope_row_instance;
  }
  function ThScope_rowGroup_getInstance() {
    ThScope_initEntries();
    return ThScope_rowGroup_instance;
  }
  function AreaShape_rect_getInstance() {
    AreaShape_initEntries();
    return AreaShape_rect_instance;
  }
  function AreaShape_circle_getInstance() {
    AreaShape_initEntries();
    return AreaShape_circle_instance;
  }
  function AreaShape_poly_getInstance() {
    AreaShape_initEntries();
    return AreaShape_poly_instance;
  }
  function AreaShape_default_getInstance() {
    AreaShape_initEntries();
    return AreaShape_default_instance;
  }
  var properties_initialized_gen_enums_kt_cpcrt1;
  function _init_properties_gen_enums_kt__jr8w3n() {
    if (!properties_initialized_gen_enums_kt_cpcrt1) {
      properties_initialized_gen_enums_kt_cpcrt1 = true;
      // Inline function 'kotlin.collections.associateBy' call
      var this_0 = values_3();
      var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination = LinkedHashMap_init_$Create$_1(capacity);
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$2 = element.s1h_1;
        destination.m2(tmp$ret$2, element);
      }
      dirValues = destination;
      // Inline function 'kotlin.collections.associateBy' call
      var this_1 = values_4();
      var capacity_0 = coerceAtLeast(mapCapacity(this_1.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_0 = LinkedHashMap_init_$Create$_1(capacity_0);
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp$ret$2_0 = element_0.v1h_1;
        destination_0.m2(tmp$ret$2_0, element_0);
      }
      draggableValues = destination_0;
      // Inline function 'kotlin.collections.associateBy' call
      var this_2 = values_13();
      var capacity_1 = coerceAtLeast(mapCapacity(this_2.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_1 = LinkedHashMap_init_$Create$_1(capacity_1);
      var inductionVariable_1 = 0;
      var last_1 = this_2.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = this_2[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var tmp$ret$2_1 = element_1.w1i_1;
        destination_1.m2(tmp$ret$2_1, element_1);
      }
      runAtValues = destination_1;
      // Inline function 'kotlin.collections.associateBy' call
      var this_3 = values_17();
      var capacity_2 = coerceAtLeast(mapCapacity(this_3.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_2 = LinkedHashMap_init_$Create$_1(capacity_2);
      var inductionVariable_2 = 0;
      var last_2 = this_3.length;
      while (inductionVariable_2 < last_2) {
        var element_2 = this_3[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var tmp$ret$2_2 = element_2.i1j_1;
        destination_2.m2(tmp$ret$2_2, element_2);
      }
      areaShapeValues = destination_2;
      // Inline function 'kotlin.collections.associateBy' call
      var this_4 = values();
      var capacity_3 = coerceAtLeast(mapCapacity(this_4.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_3 = LinkedHashMap_init_$Create$_1(capacity_3);
      var inductionVariable_3 = 0;
      var last_3 = this_4.length;
      while (inductionVariable_3 < last_3) {
        var element_3 = this_4[inductionVariable_3];
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var tmp$ret$2_3 = element_3.g1h_1;
        destination_3.m2(tmp$ret$2_3, element_3);
      }
      buttonFormEncTypeValues = destination_3;
      // Inline function 'kotlin.collections.associateBy' call
      var this_5 = values_0();
      var capacity_4 = coerceAtLeast(mapCapacity(this_5.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_4 = LinkedHashMap_init_$Create$_1(capacity_4);
      var inductionVariable_4 = 0;
      var last_4 = this_5.length;
      while (inductionVariable_4 < last_4) {
        var element_4 = this_5[inductionVariable_4];
        inductionVariable_4 = inductionVariable_4 + 1 | 0;
        var tmp$ret$2_4 = element_4.j1h_1;
        destination_4.m2(tmp$ret$2_4, element_4);
      }
      buttonFormMethodValues = destination_4;
      // Inline function 'kotlin.collections.associateBy' call
      var this_6 = values_1();
      var capacity_5 = coerceAtLeast(mapCapacity(this_6.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_5 = LinkedHashMap_init_$Create$_1(capacity_5);
      var inductionVariable_5 = 0;
      var last_5 = this_6.length;
      while (inductionVariable_5 < last_5) {
        var element_5 = this_6[inductionVariable_5];
        inductionVariable_5 = inductionVariable_5 + 1 | 0;
        var tmp$ret$2_5 = element_5.m1h_1;
        destination_5.m2(tmp$ret$2_5, element_5);
      }
      buttonTypeValues = destination_5;
      // Inline function 'kotlin.collections.associateBy' call
      var this_7 = values_2();
      var capacity_6 = coerceAtLeast(mapCapacity(this_7.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_6 = LinkedHashMap_init_$Create$_1(capacity_6);
      var inductionVariable_6 = 0;
      var last_6 = this_7.length;
      while (inductionVariable_6 < last_6) {
        var element_6 = this_7[inductionVariable_6];
        inductionVariable_6 = inductionVariable_6 + 1 | 0;
        var tmp$ret$2_6 = element_6.p1h_1;
        destination_6.m2(tmp$ret$2_6, element_6);
      }
      commandTypeValues = destination_6;
      // Inline function 'kotlin.collections.associateBy' call
      var this_8 = values_5();
      var capacity_7 = coerceAtLeast(mapCapacity(this_8.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_7 = LinkedHashMap_init_$Create$_1(capacity_7);
      var inductionVariable_7 = 0;
      var last_7 = this_8.length;
      while (inductionVariable_7 < last_7) {
        var element_7 = this_8[inductionVariable_7];
        inductionVariable_7 = inductionVariable_7 + 1 | 0;
        var tmp$ret$2_7 = element_7.y1h_1;
        destination_7.m2(tmp$ret$2_7, element_7);
      }
      formEncTypeValues = destination_7;
      // Inline function 'kotlin.collections.associateBy' call
      var this_9 = values_6();
      var capacity_8 = coerceAtLeast(mapCapacity(this_9.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_8 = LinkedHashMap_init_$Create$_1(capacity_8);
      var inductionVariable_8 = 0;
      var last_8 = this_9.length;
      while (inductionVariable_8 < last_8) {
        var element_8 = this_9[inductionVariable_8];
        inductionVariable_8 = inductionVariable_8 + 1 | 0;
        var tmp$ret$2_8 = element_8.b1i_1;
        destination_8.m2(tmp$ret$2_8, element_8);
      }
      formMethodValues = destination_8;
      // Inline function 'kotlin.collections.associateBy' call
      var this_10 = values_7();
      var capacity_9 = coerceAtLeast(mapCapacity(this_10.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_9 = LinkedHashMap_init_$Create$_1(capacity_9);
      var inductionVariable_9 = 0;
      var last_9 = this_10.length;
      while (inductionVariable_9 < last_9) {
        var element_9 = this_10[inductionVariable_9];
        inductionVariable_9 = inductionVariable_9 + 1 | 0;
        var tmp$ret$2_9 = element_9.e1i_1;
        destination_9.m2(tmp$ret$2_9, element_9);
      }
      iframeSandboxValues = destination_9;
      // Inline function 'kotlin.collections.associateBy' call
      var this_11 = values_8();
      var capacity_10 = coerceAtLeast(mapCapacity(this_11.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_10 = LinkedHashMap_init_$Create$_1(capacity_10);
      var inductionVariable_10 = 0;
      var last_10 = this_11.length;
      while (inductionVariable_10 < last_10) {
        var element_10 = this_11[inductionVariable_10];
        inductionVariable_10 = inductionVariable_10 + 1 | 0;
        var tmp$ret$2_10 = element_10.h1i_1;
        destination_10.m2(tmp$ret$2_10, element_10);
      }
      imgLoadingValues = destination_10;
      // Inline function 'kotlin.collections.associateBy' call
      var this_12 = values_11();
      var capacity_11 = coerceAtLeast(mapCapacity(this_12.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_11 = LinkedHashMap_init_$Create$_1(capacity_11);
      var inductionVariable_11 = 0;
      var last_11 = this_12.length;
      while (inductionVariable_11 < last_11) {
        var element_11 = this_12[inductionVariable_11];
        inductionVariable_11 = inductionVariable_11 + 1 | 0;
        var tmp$ret$2_11 = element_11.q1i_1;
        destination_11.m2(tmp$ret$2_11, element_11);
      }
      inputTypeValues = destination_11;
      // Inline function 'kotlin.collections.associateBy' call
      var this_13 = values_9();
      var capacity_12 = coerceAtLeast(mapCapacity(this_13.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_12 = LinkedHashMap_init_$Create$_1(capacity_12);
      var inductionVariable_12 = 0;
      var last_12 = this_13.length;
      while (inductionVariable_12 < last_12) {
        var element_12 = this_13[inductionVariable_12];
        inductionVariable_12 = inductionVariable_12 + 1 | 0;
        var tmp$ret$2_12 = element_12.k1i_1;
        destination_12.m2(tmp$ret$2_12, element_12);
      }
      inputFormEncTypeValues = destination_12;
      // Inline function 'kotlin.collections.associateBy' call
      var this_14 = values_10();
      var capacity_13 = coerceAtLeast(mapCapacity(this_14.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_13 = LinkedHashMap_init_$Create$_1(capacity_13);
      var inductionVariable_13 = 0;
      var last_13 = this_14.length;
      while (inductionVariable_13 < last_13) {
        var element_13 = this_14[inductionVariable_13];
        inductionVariable_13 = inductionVariable_13 + 1 | 0;
        var tmp$ret$2_13 = element_13.n1i_1;
        destination_13.m2(tmp$ret$2_13, element_13);
      }
      inputFormMethodValues = destination_13;
      // Inline function 'kotlin.collections.associateBy' call
      var this_15 = values_12();
      var capacity_14 = coerceAtLeast(mapCapacity(this_15.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_14 = LinkedHashMap_init_$Create$_1(capacity_14);
      var inductionVariable_14 = 0;
      var last_14 = this_15.length;
      while (inductionVariable_14 < last_14) {
        var element_14 = this_15[inductionVariable_14];
        inductionVariable_14 = inductionVariable_14 + 1 | 0;
        var tmp$ret$2_14 = element_14.t1i_1;
        destination_14.m2(tmp$ret$2_14, element_14);
      }
      keyGenKeyTypeValues = destination_14;
      // Inline function 'kotlin.collections.associateBy' call
      var this_16 = values_14();
      var capacity_15 = coerceAtLeast(mapCapacity(this_16.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_15 = LinkedHashMap_init_$Create$_1(capacity_15);
      var inductionVariable_15 = 0;
      var last_15 = this_16.length;
      while (inductionVariable_15 < last_15) {
        var element_15 = this_16[inductionVariable_15];
        inductionVariable_15 = inductionVariable_15 + 1 | 0;
        var tmp$ret$2_15 = element_15.z1i_1;
        destination_15.m2(tmp$ret$2_15, element_15);
      }
      scriptCrossoriginValues = destination_15;
      // Inline function 'kotlin.collections.associateBy' call
      var this_17 = values_15();
      var capacity_16 = coerceAtLeast(mapCapacity(this_17.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_16 = LinkedHashMap_init_$Create$_1(capacity_16);
      var inductionVariable_16 = 0;
      var last_16 = this_17.length;
      while (inductionVariable_16 < last_16) {
        var element_16 = this_17[inductionVariable_16];
        inductionVariable_16 = inductionVariable_16 + 1 | 0;
        var tmp$ret$2_16 = element_16.c1j_1;
        destination_16.m2(tmp$ret$2_16, element_16);
      }
      textAreaWrapValues = destination_16;
      // Inline function 'kotlin.collections.associateBy' call
      var this_18 = values_16();
      var capacity_17 = coerceAtLeast(mapCapacity(this_18.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_17 = LinkedHashMap_init_$Create$_1(capacity_17);
      var inductionVariable_17 = 0;
      var last_17 = this_18.length;
      while (inductionVariable_17 < last_17) {
        var element_17 = this_18[inductionVariable_17];
        inductionVariable_17 = inductionVariable_17 + 1 | 0;
        var tmp$ret$2_17 = element_17.f1j_1;
        destination_17.m2(tmp$ret$2_17, element_17);
      }
      thScopeValues = destination_17;
    }
  }
  function A(initialAttributes, consumer) {
    HTMLTag.call(this, 'a', consumer, initialAttributes, null, true, false);
    this.p1j_1 = consumer;
  }
  protoOf(A).j1f = function () {
    return this.p1j_1;
  };
  protoOf(A).q1j = function (newValue) {
    get_attributeStringString().c1g(this, 'href', newValue);
  };
  function BUTTON(initialAttributes, consumer) {
    HTMLTag.call(this, 'button', consumer, initialAttributes, null, true, false);
    this.x1j_1 = consumer;
  }
  protoOf(BUTTON).j1f = function () {
    return this.x1j_1;
  };
  protoOf(BUTTON).y1j = function (newValue) {
    get_attributeBooleanTicker().c1g(this, 'disabled', newValue);
  };
  protoOf(BUTTON).z1j = function (newValue) {
    get_attributeButtonTypeEnumButtonTypeValues().c1g(this, 'type', newValue);
  };
  function DIV(initialAttributes, consumer) {
    HTMLTag.call(this, 'div', consumer, initialAttributes, null, false, false);
    this.g1k_1 = consumer;
  }
  protoOf(DIV).j1f = function () {
    return this.g1k_1;
  };
  function FORM(initialAttributes, consumer) {
    HTMLTag.call(this, 'form', consumer, initialAttributes, null, false, false);
    this.n1k_1 = consumer;
  }
  protoOf(FORM).j1f = function () {
    return this.n1k_1;
  };
  function H3(initialAttributes, consumer) {
    HTMLTag.call(this, 'h3', consumer, initialAttributes, null, false, false);
    this.u1k_1 = consumer;
  }
  protoOf(H3).j1f = function () {
    return this.u1k_1;
  };
  function H4(initialAttributes, consumer) {
    HTMLTag.call(this, 'h4', consumer, initialAttributes, null, false, false);
    this.b1l_1 = consumer;
  }
  protoOf(H4).j1f = function () {
    return this.b1l_1;
  };
  function H2(initialAttributes, consumer) {
    HTMLTag.call(this, 'h2', consumer, initialAttributes, null, false, false);
    this.i1l_1 = consumer;
  }
  protoOf(H2).j1f = function () {
    return this.i1l_1;
  };
  function H1(initialAttributes, consumer) {
    HTMLTag.call(this, 'h1', consumer, initialAttributes, null, false, false);
    this.p1l_1 = consumer;
  }
  protoOf(H1).j1f = function () {
    return this.p1l_1;
  };
  function INPUT(initialAttributes, consumer) {
    HTMLTag.call(this, 'input', consumer, initialAttributes, null, true, true);
    this.w1l_1 = consumer;
  }
  protoOf(INPUT).j1f = function () {
    return this.w1l_1;
  };
  protoOf(INPUT).x1l = function (newValue) {
    get_attributeStringString().c1g(this, 'accept', newValue);
  };
  protoOf(INPUT).y1l = function (newValue) {
    get_attributeBooleanTicker().c1g(this, 'checked', newValue);
  };
  protoOf(INPUT).z1l = function (newValue) {
    get_attributeStringString().c1g(this, 'maxlength', newValue);
  };
  protoOf(INPUT).a1m = function (newValue) {
    get_attributeStringString().c1g(this, 'minlength', newValue);
  };
  protoOf(INPUT).b1m = function (newValue) {
    get_attributeStringString().c1g(this, 'placeholder', newValue);
  };
  protoOf(INPUT).c1m = function (newValue) {
    get_attributeBooleanTicker().c1g(this, 'required', newValue);
  };
  protoOf(INPUT).d1m = function (newValue) {
    get_attributeStringString().c1g(this, 'value', newValue);
  };
  function IMG(initialAttributes, consumer) {
    HTMLTag.call(this, 'img', consumer, initialAttributes, null, true, true);
    this.k1m_1 = consumer;
  }
  protoOf(IMG).j1f = function () {
    return this.k1m_1;
  };
  protoOf(IMG).l1m = function (newValue) {
    get_attributeStringString().c1g(this, 'alt', newValue);
  };
  protoOf(IMG).m1m = function (newValue) {
    get_attributeStringString().c1g(this, 'src', newValue);
  };
  protoOf(IMG).n1m = function (newValue) {
    get_attributeStringString().c1g(this, 'width', newValue);
  };
  function LABEL(initialAttributes, consumer) {
    HTMLTag.call(this, 'label', consumer, initialAttributes, null, true, false);
    this.u1m_1 = consumer;
  }
  protoOf(LABEL).j1f = function () {
    return this.u1m_1;
  };
  function LI(initialAttributes, consumer) {
    HTMLTag.call(this, 'li', consumer, initialAttributes, null, false, false);
    this.b1n_1 = consumer;
  }
  protoOf(LI).j1f = function () {
    return this.b1n_1;
  };
  function OPTION(initialAttributes, consumer) {
    HTMLTag.call(this, 'option', consumer, initialAttributes, null, true, false);
    this.i1n_1 = consumer;
  }
  protoOf(OPTION).j1f = function () {
    return this.i1n_1;
  };
  protoOf(OPTION).d1m = function (newValue) {
    get_attributeStringString().c1g(this, 'value', newValue);
  };
  function OL(initialAttributes, consumer) {
    HTMLTag.call(this, 'ol', consumer, initialAttributes, null, false, false);
    this.p1n_1 = consumer;
  }
  protoOf(OL).j1f = function () {
    return this.p1n_1;
  };
  function P(initialAttributes, consumer) {
    HTMLTag.call(this, 'p', consumer, initialAttributes, null, false, false);
    this.w1n_1 = consumer;
  }
  protoOf(P).j1f = function () {
    return this.w1n_1;
  };
  function SVG(initialAttributes, consumer) {
    HTMLTag.call(this, 'svg', consumer, initialAttributes, 'http://www.w3.org/2000/svg', false, false);
    this.d1o_1 = consumer;
  }
  protoOf(SVG).j1f = function () {
    return this.d1o_1;
  };
  function SELECT(initialAttributes, consumer) {
    HTMLTag.call(this, 'select', consumer, initialAttributes, null, true, false);
    this.k1o_1 = consumer;
  }
  protoOf(SELECT).j1f = function () {
    return this.k1o_1;
  };
  function SPAN(initialAttributes, consumer) {
    HTMLTag.call(this, 'span', consumer, initialAttributes, null, true, false);
    this.r1o_1 = consumer;
  }
  protoOf(SPAN).j1f = function () {
    return this.r1o_1;
  };
  function TABLE(initialAttributes, consumer) {
    HTMLTag.call(this, 'table', consumer, initialAttributes, null, false, false);
    this.y1o_1 = consumer;
  }
  protoOf(TABLE).j1f = function () {
    return this.y1o_1;
  };
  function TR(initialAttributes, consumer) {
    HTMLTag.call(this, 'tr', consumer, initialAttributes, null, false, false);
    this.f1p_1 = consumer;
  }
  protoOf(TR).j1f = function () {
    return this.f1p_1;
  };
  function TH(initialAttributes, consumer) {
    HTMLTag.call(this, 'th', consumer, initialAttributes, null, false, false);
    this.m1p_1 = consumer;
  }
  protoOf(TH).j1f = function () {
    return this.m1p_1;
  };
  function TD(initialAttributes, consumer) {
    HTMLTag.call(this, 'td', consumer, initialAttributes, null, false, false);
    this.t1p_1 = consumer;
  }
  protoOf(TD).j1f = function () {
    return this.t1p_1;
  };
  function TEXTAREA(initialAttributes, consumer) {
    HTMLTag.call(this, 'textarea', consumer, initialAttributes, null, true, false);
    this.a1q_1 = consumer;
  }
  protoOf(TEXTAREA).j1f = function () {
    return this.a1q_1;
  };
  protoOf(TEXTAREA).b1q = function (newValue) {
    get_attributeStringString().c1g(this, 'rows', newValue);
  };
  protoOf(TEXTAREA).c1q = function (newValue) {
    get_attributeStringString().c1g(this, 'cols', newValue);
  };
  function UL(initialAttributes, consumer) {
    HTMLTag.call(this, 'ul', consumer, initialAttributes, null, false, false);
    this.j1q_1 = consumer;
  }
  protoOf(UL).j1f = function () {
    return this.j1q_1;
  };
  function HTMLTag$attributes$lambda(this$0) {
    return function () {
      return this$0.j1f();
    };
  }
  function HTMLTag(tagName, consumer, initialAttributes, namespace, inlineTag, emptyTag) {
    namespace = namespace === VOID ? null : namespace;
    this.r1f_1 = tagName;
    this.s1f_1 = consumer;
    this.t1f_1 = namespace;
    this.u1f_1 = inlineTag;
    this.v1f_1 = emptyTag;
    var tmp = this;
    tmp.w1f_1 = new DelegatingMap(initialAttributes, this, HTMLTag$attributes$lambda(this));
  }
  protoOf(HTMLTag).i1f = function () {
    return this.r1f_1;
  };
  protoOf(HTMLTag).j1f = function () {
    return this.s1f_1;
  };
  protoOf(HTMLTag).k1f = function () {
    return this.t1f_1;
  };
  protoOf(HTMLTag).l1f = function () {
    return this.w1f_1;
  };
  protoOf(HTMLTag).m1f = function () {
    return this.l1f().w1g();
  };
  function append(_this__u8e3s4, block) {
    // Inline function 'kotlin.let' call
    var result = ArrayList_init_$Create$();
    var tmp = createTree(get_ownerDocumentExt(_this__u8e3s4));
    block(onFinalize(tmp, append$lambda(result, _this__u8e3s4)));
    return result;
  }
  function createTree(_this__u8e3s4) {
    return new JSDOMBuilder(_this__u8e3s4);
  }
  function get_ownerDocumentExt(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof Document) {
      tmp = _this__u8e3s4;
    } else {
      var tmp0_elvis_lhs = _this__u8e3s4.ownerDocument;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        throw IllegalStateException_init_$Create$('Node has no ownerDocument');
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function asR($this, $receiver) {
    // Inline function 'kotlin.js.asDynamic' call
    return $receiver;
  }
  function JSDOMBuilder(document) {
    this.k1q_1 = document;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.l1q_1 = ArrayList_init_$Create$();
    this.m1q_1 = null;
  }
  protoOf(JSDOMBuilder).a1h = function (tag) {
    var tmp;
    if (!(tag.k1f() == null)) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.k1q_1.createElementNS(ensureNotNull(tag.k1f()), tag.i1f());
    } else {
      var tmp_0 = this.k1q_1.createElement(tag.i1f());
      tmp = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    }
    var element = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tag.m1f().t();
    while (_iterator__ex2g4s.u()) {
      var element_0 = _iterator__ex2g4s.v();
      element.setAttribute(element_0.e2(), element_0.f2());
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.l1q_1.r()) {
      last(this.l1q_1).appendChild(element);
    }
    this.l1q_1.x(element);
  };
  protoOf(JSDOMBuilder).u1g = function (tag, attribute, value) {
    if (this.l1q_1.r())
      throw IllegalStateException_init_$Create$('No current tag');
    else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = last(this.l1q_1).tagName.toLowerCase();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(tmp === tag.i1f().toLowerCase()))
        throw IllegalStateException_init_$Create$('Wrong current tag');
      else {
        // Inline function 'kotlin.let' call
        var node = last(this.l1q_1);
        if (value == null) {
          node.removeAttribute(attribute);
        } else {
          node.setAttribute(attribute, value);
        }
      }
    }
  };
  protoOf(JSDOMBuilder).c1h = function (tag, event, value) {
    if (this.l1q_1.r())
      throw IllegalStateException_init_$Create$('No current tag');
    else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = last(this.l1q_1).tagName.toLowerCase();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(tmp === tag.i1f().toLowerCase()))
        throw IllegalStateException_init_$Create$('Wrong current tag');
      else {
        // Inline function 'kotlinx.html.dom.setEvent' call
        // Inline function 'kotlin.js.asDynamic' call
        last(this.l1q_1)[event] = value;
      }
    }
  };
  protoOf(JSDOMBuilder).b1h = function (tag) {
    var tmp;
    if (this.l1q_1.r()) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = last(this.l1q_1).tagName.toLowerCase();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = !(tmp_0 === tag.i1f().toLowerCase());
    }
    if (tmp) {
      throw IllegalStateException_init_$Create$("We haven't entered tag " + tag.i1f() + ' but trying to leave');
    }
    this.m1q_1 = this.l1q_1.q2(get_lastIndex(this.l1q_1));
  };
  protoOf(JSDOMBuilder).p1f = function (content) {
    if (this.l1q_1.r()) {
      throw IllegalStateException_init_$Create$('No current DOM node');
    }
    last(this.l1q_1).appendChild(this.k1q_1.createTextNode(toString(content)));
  };
  protoOf(JSDOMBuilder).x1f = function (block) {
    // Inline function 'kotlin.with' call
    var $this$with = new DefaultUnsafe();
    block($this$with);
    var tmp0_this = last(this.l1q_1);
    tmp0_this.innerHTML = tmp0_this.innerHTML + $this$with.toString();
  };
  protoOf(JSDOMBuilder).d1h = function () {
    var tmp0_safe_receiver = this.m1q_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : asR(this, tmp0_safe_receiver);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$("We can't finalize as there was no tags");
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  function append$lambda($result, $this_append) {
    return function (it, partial) {
      var tmp;
      if (!partial) {
        $result.x(it);
        $this_append.appendChild(it);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function set_onFocusFunction(_this__u8e3s4, newValue) {
    _this__u8e3s4.j1f().c1h(_this__u8e3s4, 'onfocus', newValue);
  }
  function set_onInputFunction(_this__u8e3s4, newValue) {
    _this__u8e3s4.j1f().c1h(_this__u8e3s4, 'oninput', newValue);
  }
  function set_onBlurFunction(_this__u8e3s4, newValue) {
    _this__u8e3s4.j1f().c1h(_this__u8e3s4, 'onblur', newValue);
  }
  function set_onClickFunction(_this__u8e3s4, newValue) {
    _this__u8e3s4.j1f().c1h(_this__u8e3s4, 'onclick', newValue);
  }
  function set_onKeyDownFunction(_this__u8e3s4, newValue) {
    _this__u8e3s4.j1f().c1h(_this__u8e3s4, 'onkeydown', newValue);
  }
  //region block: post-declaration
  protoOf(DefaultUnsafe).q1f = raw;
  protoOf(HTMLTag).n1f = unaryPlus;
  protoOf(HTMLTag).o1f = text;
  //endregion
  //region block: init
  StringEncoder_instance = new StringEncoder();
  StringSetEncoder_instance = new StringSetEncoder();
  TickerEncoder_instance = new TickerEncoder();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = ButtonType_button_getInstance;
  _.$_$.b = ButtonType_submit_getInstance;
  _.$_$.c = InputType_checkBox_getInstance;
  _.$_$.d = InputType_email_getInstance;
  _.$_$.e = InputType_file_getInstance;
  _.$_$.f = InputType_hidden_getInstance;
  _.$_$.g = InputType_number_getInstance;
  _.$_$.h = InputType_password_getInstance;
  _.$_$.i = InputType_text_getInstance;
  _.$_$.j = enumEncode;
  _.$_$.k = append;
  _.$_$.l = set_onBlurFunction;
  _.$_$.m = set_onClickFunction;
  _.$_$.n = set_onFocusFunction;
  _.$_$.o = set_onInputFunction;
  _.$_$.p = set_onKeyDownFunction;
  _.$_$.q = A;
  _.$_$.r = BUTTON;
  _.$_$.s = DIV;
  _.$_$.t = FORM;
  _.$_$.u = H1;
  _.$_$.v = H2;
  _.$_$.w = H3;
  _.$_$.x = H4;
  _.$_$.y = IMG;
  _.$_$.z = INPUT;
  _.$_$.a1 = LABEL;
  _.$_$.b1 = LI;
  _.$_$.c1 = OL;
  _.$_$.d1 = OPTION;
  _.$_$.e1 = P;
  _.$_$.f1 = SELECT;
  _.$_$.g1 = SPAN;
  _.$_$.h1 = SVG;
  _.$_$.i1 = TABLE;
  _.$_$.j1 = TD;
  _.$_$.k1 = TEXTAREA;
  _.$_$.l1 = TH;
  _.$_$.m1 = TR;
  _.$_$.n1 = UL;
  _.$_$.o1 = attributesMapOf_0;
  _.$_$.p1 = attributesMapOf;
  _.$_$.q1 = set_classes;
  _.$_$.r1 = set_id;
  _.$_$.s1 = unsafe;
  //endregion
  return _;
}));

